import * as angular from "angular";
import { getDistinctValues, isUndefined } from "../../omnia";

export interface ISelection {

    planMode?: boolean;

    closing?: number;

    croppingId?: number;
    planId?: number;
    appId?: number;

    zoneNumber?: number;

    mapView?: string;

}


export class DashboardSelection {


    constructor(private _selection: ISelection) {
        this._selection = _selection || {};
    }

    cloneSelection(properties?: {}): ISelection {
        return angular.extend({}, this._selection, properties);
    }

    get planMode() {
        return this._selection.planMode;
    }

    get croppingMode() {
        return !this._selection.planMode;
    }

    get croppingId() {
        return this._selection.croppingId;
    }

    get planId() {
        return this._selection.planId;
    }

    get appId() {
        return this._selection.appId;
    }

    get closing() {
        return this._selection.closing;
    }

    get zoneNumber() {
        return this._selection.zoneNumber;
    }

    get mapView() {
        return this._selection.mapView;
    }

    clear(planMode: boolean, mapView?: string, closing?: number) {
        return this.select2({ planMode, mapView, closing });
    }

    openCropping(croppingId: number, closing?: number) {
        let s = <ISelection>{
            planMode: false,
            croppingId: croppingId,
            zoneNumber: this.zoneNumber,
            closing: closing,
        }
        return this.select2(s);
    }

    focusCropping(croppingId: number, zoneNumber: number) {
        let s = this.cloneSelection();
        s.croppingId = croppingId;
        s.zoneNumber = isUndefined(zoneNumber) ? this.zoneNumber : zoneNumber;
        return this.select2(s);
    }

    openPlan(planId: number) {
        let s = <ISelection>{
            planMode: true,
            planId: planId,
        }
        return this.select2(s);
    }

    focusPlanCropping(croppingId: number) {
        return this.select(true, croppingId, this.planId, null);
    }

    focusCroppingPlan(planId: number) {
        return this.select(false, this.croppingId, planId, null);
    }

    focusApplication(croppingId: number, planId: number, appId: number) {
        return this.select(this.planMode, croppingId, planId, appId);
    }

    selectZone(zoneNumber: number) {
        if (zoneNumber == this.zoneNumber) return this;
        let s = this.cloneSelection();
        s.zoneNumber = zoneNumber;
        return new DashboardSelection(s);
    }

    setMapView(view: string, closing?: number) {
        let s = this.cloneSelection({ mapView: view, closing });
        return this.select2(s);
    }

    private select(planMode: boolean, croppingId?: number, planId?: number, appId?: number, closing?: number, zoneNumber?: number) {

        croppingId = isUndefined(croppingId) ? this.croppingId : croppingId;
        planId = isUndefined(planId) ? this.planId : planId;
        appId = isUndefined(appId) ? this.appId : appId;
        closing = isUndefined(closing) ? this.closing : closing;

        let s = <ISelection>{
            planMode: planMode,
            closing: closing,
            croppingId: croppingId,
            planId: planId,
            appId: appId,
            zoneNumber: zoneNumber
        };

        return this.select2(s);

    }

    private select2(sel: ISelection) {

        let keys = getDistinctValues(Object.keys(this._selection).concat(Object.keys(sel)), k => k);

        if (keys.every(k => sel[k] == this._selection[k])) {
            return this;
        }

        return new DashboardSelection(sel);

    }

}
